var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGirl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 288 407.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "b",
    cx: -100.5,
    cy: 208,
    r: 36.9,
    gradientTransform: "matrix(.97333 0 0 .9018 395 67)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "c",
    cx: -100.5,
    cy: 208,
    r: 36.9,
    gradientTransform: "matrix(.97333 0 0 .9018 499 78)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbb300",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff007f",
    strokeWidth: 1.9,
    d: "M120.4 156.3s2 37.3-14.8 74.7C88.8 268.3 59 299.3 61 299.3c-2.1 0 37.3 7.3 109.8 10.5 96.7-5.3 87.8-19 87.8-19-10-15.7-75.7-84-77.8-139.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f007f",
    strokeWidth: 1.8,
    d: "M118.2 148s10 28.8-7.3 73C75.7 272.5 72 283.5 74 283.5c-2.1 0 24.2 7.9 96.7 11 96.7-4.7 74.6-19.4 74.6-19.4a260.7 260.7 0 0 1-66.7-131.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff007f",
    strokeWidth: 2,
    d: "M132 125.3s-31.6 29.5-11.1 25.8c20.5-3.2 20-3.2 30 5.8 10.4 8.4 6.8-17.4 19.4-11 13.1 6.8 10-24.3 3.1-27.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc886",
    strokeWidth: 1.9,
    d: "M130.3 124.8c-1.5 2.6 20.5 32.6 34.7-.5"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ff007f",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116 395a18 18 0 1 1-36 0 18 18 0 1 1 36 0z",
    transform: "matrix(.52555 0 0 .4613 105.6 28.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 411a18 18 0 1 1-36 0 18 18 0 1 1 36 0z",
    transform: "matrix(.52555 0 0 .4613 105.6 28.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 439a18 18 0 1 1-36 0 18 18 0 1 1 36 0z",
    transform: "matrix(.52555 0 0 .4613 105.6 28.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 451a18 18 0 1 1-36 0 18 18 0 1 1 36 0z",
    transform: "matrix(.52555 0 0 .4613 105.6 28.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 419a18 18 0 1 1-36 0 18 18 0 1 1 36 0z",
    transform: "matrix(.52555 0 0 .4613 105.6 28.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 419a18 18 0 1 1-36 0 18 18 0 1 1 36 0z",
    transform: "matrix(.52555 0 0 .4613 105.6 28.1)"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2 162.6c53.1 20 101-12 101-12m65.1-4.8c52.6 20 26.8 78.3 26.8 78.3m-87.7 179.2c2-48.8 8.4-95.6 8.4-95.6M154 398c1.6-41.5 12-88.3 12-88.3M15.3 161s-7.8-9.5-9.4-5.3c0 3.2 6.8 6.8-2.6 14.7 2.6 5.3 12-9.4 12-9.4z",
    fill: "none",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.3 404.4c1-1.6 5.3-4.2-3.7-5.8-18.9-3.1-23.6-2-26.3 3.7 3.7 6.3 26.3 3.7 30 2zm63-9c.6-1.5 4.3-5.2-4.7-4.7-19.4 1.6-23.6 3.7-24.7 10 5.3 4.7 26.8-2.6 29.5-5.2z",
    fill: "#3f007f",
    strokeWidth: 2.5
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 62.8c3.1.5 6.8 1.6 10.5 1.6 11 1 17.8-2.7-1 4.2 4.1-1.6 3.6-2.7 4.1-4.2l2.7-4.8C44 53.3 44 54 55.7 55c13.1-.5 15.8-2.6 0 2.6.5-1.5-1-3.1-1-5.2 14.1-6.9 13.1-4.8 26.8-6.3 8.4-1.6 25.7-6.9-1.6 1.5.5-2 1-3.6 0-5.2-3.2-3.2 10-7.9 20-7.9h11.5c-15.2 6.3-10 4.2-12 0-1.1-3.7 14.1-8.4 22-7.4l10.5.6c11-3.7-12.6 7.3-4.7 1.6 0-2.2-1-3.2-3.2-4.3l13.2-4.7c2.6 1 3.6 2.1 3.6 4.2-1.5 3.2-11.5 7.4-21 8.4l-11.5-.5c-12.7.5 8.9-6.3 4.7-2.6 2 4.2 3.1 4.7-13.7 10h-12c-12.1.5 10.5-7.4 6.8-2.1.5 1.5.5 3.1-.6 5.2-.5 4.2-14.1 6.8-24.1 8.4-12.6 1.6-16.8 1.6 0-3.1-.6 1.5 0 3.1.5 4.7-9 4.2-14.7 7.9-26.8 7.4-11-1-16.3 1 1.6-5.3-1.6 1.6-3.2 3.2-3.2 4.7-1 1.6 0 3.2-3.7 4.8-12.6 4.7-14.2 6.8-26.2 5.2L0 67.6Zm260.1-2.1-10.5 2c-11 1.1-17.9-3 1 4.3-3.6-1.6-3.6-3.2-3.6-4.7l-3.2-4.8c-14.2-5.8-13.6-5.8-25.2-4.2-13.7-1-16.3-3.1-.5 2.7l1-5.3c-14.2-6.8-13.1-4.7-26.3-6.8-8.9-1-26.2-6.9 1.6 1.5-.5-1.5-1-3.1-.5-4.7 3.1-3.7-10-8.4-20-8.4-3.7 1-6.3 1-11.5 0 15.2 6.3 10.5 4.2 12 0 1.6-3.1-13.6-8.4-22-6.8l-10.5.5c-10.5-3.7 13.1 7.4 5.2 1-.5-1.5.5-2.6 3.2-3.6L150.3 18c-2.6 1-3.7 2.6-3.7 4.2 1.6 3.2 11.6 7.4 21 9l11.6-1.1c13.2.5-9-6.3-4.7-2.6-2.1 4.7-3.2 4.7 13.6 10 5.3 1 8.5 1 12.1 0 12.1 1-10.5-7.4-6.3-1.6-.5 1.6-1 3.1 0 4.7 1 4.2 14.2 7.4 24.7 8.4 12.1 1.6 16.3 2.1 0-3.1.6 1.5 0 3.1-1 5.2 9 3.7 14.7 7.4 27.3 6.9 10.5-1 15.8 1-1.6-4.8 1.6 1.6 3.2 3.2 3.2 4.2.5 2.1-.5 3.2 3.1 4.8 12.6 4.7 14.8 6.8 26.8 5.7l11.6-2Z",
    fill: "#180030",
    style: {
      strokeWidth: 0.525547
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff007f",
    strokeWidth: 2,
    d: "M149.3 20.2 124.6 4l-6.9 14.2 32.6 5.8 33.1-12-14.7-10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc886",
    strokeWidth: 1.9,
    d: "M207 68c0 29-33.6 57.9-63 57.9-29 0-58.3-16.3-58.3-45.2 0-29 29.4-60 58.3-60 29.4 0 63 18.4 63 47.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.3 77a3.2 2.6 0 1 1-6.3 0 3.2 2.6 0 1 1 6.3 0zm17.9 0a3.2 2.6 0 1 1-6.3 0 3.2 2.6 0 1 1 6.3 0z",
    strokeWidth: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    d: "M122 88.5c15.2 38.4 39.3 31.6 48.8 4.2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#180030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m251.7 88-9.4-.5c-9.5-1.6-14.2-6.8 0 4.2-3.2-2.6-2.1-3.7-2.1-5.3l-1-5.2c-10.6-9-10.6-9-20.6-10-11-3.7-12.6-6.8-.5 2.1 0-1.6 1.6-3.2 2.1-4.7-10-10-10-8-20.5-12.6-7.3-2.7-20-12.1 1 2-.5-1.5 0-3.1.6-4.7 3.7-2.6-5.8-10.5-14.2-12.6a19 19 0 0 1-10-2.6c11 9.4 7.4 6.8 10.5 3.1 1.6-3.1-9.4-11.5-16.8-12l-9-2.2c-7.8-5.7 9 10 3.7 2.7.6-2.1 1.6-2.7 3.7-3.2l-10-7.9c-2 .6-3.6 1.6-4.2 3.2 1 3.7 8 10 15.8 13.1l9.5 2.1c11 3.2-5.8-8.4-3.2-3.6-3.1 3.6-3.7 3.6 9 12.6a21 21 0 0 0 10 2.6c10 3.7-6.9-9.5-4.8-3.2-1 1.6-1.6 2.7-1 4.8-.6 4.2 10 10 17.8 13.6 10 4.2 13.7 5.8 1-3.1 0 2-1 3.7-2 4.7 6.8 5.8 10.5 11 21 13.2 9 1.5 13.1 4.7 0-5.3l1.6 5.3c0 1.5-1 3.1 1 5.2 9.5 7.4 10.5 10 21 11.6l10.5.5zM44.1 112.7l10-2.6c10.5-4.2 14.2-10.5 2.1 3.7 2.1-3.2 1-3.7.6-5.3v-5.2c8.4-11.6 8.4-11.6 19.4-15.3 11-6.8 12-9.4 1.6 2.1-1-1.6-3.2-2.6-3.7-4.2 8.4-12 8.4-10 19-17.3 6.8-4.8 18.8-17.4-.6 2L90.4 66C85.7 65 94 55 103 50.2c3.7-.6 5.8-2.1 9.5-4.8-9.5 12.1-6.3 8-10 5.3-3.7-2.6 6.8-13.7 14.7-15.8l9.5-4.2c7.3-7.9-6.9 12.1-3.7 3.2-.5-1.6-2.1-2.1-4.8-2.1l9-10c2.6 0 4.2.5 5.2 2.1.6 3.7-5.7 11-13.1 16.8L108.8 45c-11 5.8 4.2-9.4 2.6-4.2 4.2 2.6 5.3 2.6-5.8 14.7a41.6 41.6 0 0 1-11 5.3c-10 5.8 5.3-11 4.7-4.7 1.6 1 2.7 2.6 2.7 4.7 1.5 3.7-8.5 12-16.3 17.9-10 6.8-13.2 8.9-1.6-3.2 0 2.1 1.6 3.2 3.1 4.2C82 87 78.8 92.7 67.8 98c-9.5 3.2-13.1 7.9-1-5.3-.6 2.1-1.1 4.2-.6 5.3.5 1.6 2.1 2.6 0 5.8-8.4 9.4-9 12-20 16.3l-11.5 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.3 88 10.5-.5c11-1.6 16.3-6.8.6 4.2 3.1-2.6 2.6-3.7 2-5.3 0-1.5.6-3.6 1.6-5.2 11.6-9 11.6-9 23.2-10 12.6-3.7 14.7-6.8 1 2.1-.5-1.6-2-3.2-2-4.7 11.5-10 11-8 23-12.6 8.4-2.7 23.2-12.1-1 2 .5-1.5 0-3.1-1-4.7-4.3-2.6 7.3-10.5 16.8-12.6 4.2 0 6.8-.5 11-2.6-12.6 9.4-8.4 6.8-11.6 3.1-2-3.1 11-11.5 19.5-12l10.5-2.2c9-5.7-10.5 10-4.7 2.7 0-2.1-1.6-2.7-4.2-3.2l11.5-7.9c2.6.6 4.2 1.6 4.7 3.2-.5 3.7-8.9 10-17.8 13.1l-11 2.1c-12.7 3.2 6.2-8.4 3.6-3.6C116.7 37 117.7 37 103 46a26 26 0 0 1-11.6 2.6c-11.5 3.7 8-9.5 5.8-3.2 1 1.6 1.6 2.7 1 4.8.6 4.2-11.5 10-21 13.6-11.5 4.2-15.2 5.8-.5-3.1-.5 2 .6 3.7 1.6 4.7-7.4 5.8-11.6 11-23.6 13.2-10.6 1.5-15.3 4.7 0-5.3-1 2.1-2.1 3.7-1.6 5.3-.5 1.5 1 3.1-2.1 5.2-10.5 7.4-12.1 10-24.2 11.6l-11.6.5zM184 70.1l-4.2-1.5c-3.6-2.1-5.2-5.8-.5 2-1-2-.5-2.6 0-3v-2.7c-3.7-6.3-3.7-6.3-7.9-8.4-4.2-3.2-4.7-4.8-.5 1.6 0-1 1-1.6 1.6-2.7-3.7-6.3-3.7-5.2-7.9-9-2.6-2.5-7.4-8.8.5 1.1l.5-2.6c2.1-.5-1.5-5.8-4.7-7.9l-4.2-3.1c4.2 6.8 2.6 4.7 4.2 3.1 1.6-1.5-2.6-7.3-5.8-8.4l-3.6-2c-3.2-4.3 2.6 6.2 1 1.5.5-1 1-1 2.1-1l-3.1-5.3c-1.6 0-2.1 0-2.7 1 0 1.6 2.7 5.8 5.8 9l3.7 2c4.7 3.2-1.6-4.6-1-2-1.6 1.6-2.2 1.6 2.6 7.3l4.2 3.2c3.6 3.1-2.1-5.8-2.1-2.6-.6.5-1 1.5-.6 2.6-1 2 3.2 6.3 6.3 9.4 3.7 3.7 5.3 4.8.6-1.5l-1 2c2 3.8 3 7 7.3 9.5 4.2 2.1 5.2 4.2.5-2.6v3.2c0 .5-.5 1 .5 2.6 3.2 5.2 3.2 6.3 8 9l4.1 1.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M331 255a34 32 0 1 1-67 0 34 32 0 1 1 67 0z",
    style: {
      fill: "url(#b)"
    },
    transform: "translate(-41.5 -46.5) scale(.52555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M435 265a34 32 0 1 1-68 0 34 32 0 1 1 68 0z",
    style: {
      fill: "url(#c)"
    },
    transform: "translate(-41.5 -46.5) scale(.52555)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl);
export default __webpack_public_path__ + "static/media/girl.e44166cd91b2694fe30665e6e7c7167b.svg";
export { ForwardRef as ReactComponent };